import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AuthService, provideConfig } from '@spartacus/core';
import { ImageLoadingStrategy, MediaConfig } from '@spartacus/storefront';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { CustomOAuthClientTokenInterceptor } from './custom/http-interceptors/custom-oauth-client-token-interceptor';
import { CustomAuthService } from './services/auth/custom-auth.service';
import { XCustomerSegmentInterceptor } from './spartacus/custom/http-interceptors/x-customer-segment.interceptor';
import { SpartacusCustomModule } from './spartacus/spartacus-custom.module';
import { SpartacusModule } from './spartacus/spartacus.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppRoutingModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    SpartacusModule,
    SpartacusCustomModule,
    StoreDevtoolsModule.instrument({
      maxAge: 50,
      logOnly: !environment.production,
      connectInZone: true
    })
  ],
  providers: [
    provideConfig({
      imageLoadingStrategy: ImageLoadingStrategy.LAZY
    } as MediaConfig),
    { provide: HTTP_INTERCEPTORS, useClass: XCustomerSegmentInterceptor, multi: true },
    {
      provide: AuthService,
      useClass: CustomAuthService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomOAuthClientTokenInterceptor,
      multi: true
    }
  ]
})
export class AppModule {}
